import { render, staticRenderFns } from "./knowledge-base-section.vue?vue&type=template&id=ea031b0c&scoped=true"
import script from "./knowledge-base-section.vue?vue&type=script&lang=js"
export * from "./knowledge-base-section.vue?vue&type=script&lang=js"
import style0 from "./knowledge-base-section.vue?vue&type=style&index=0&id=ea031b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea031b0c",
  null
  
)

export default component.exports